// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\n    background: #fff;\n    padding: 32px 16px;\n}\n.pagination-container.hidden[data-v-72233bcd] {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
